
<div 
  #sayGoodByeViewRef
  class="say-good-bye-view"
>
  <header class="say-good-bye-view-header">
    <img 
      class="say-good-bye-view__logo" 
      src="/assets/fitur-2026/imgs/cicerone-logo.svg"
    >
  </header>
  
  <main class="say-good-bye-view-main">
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="66" viewBox="0 0 42 66" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.194 5.99648C8.3443 5.99648 5.99648 7.97842 5.99648 11.5646V54.3967C5.99648 57.9829 8.3443 59.9648 10.194 59.9648H31.7814C33.6311 59.9648 35.9789 57.9829 35.9789 54.3967V11.5646C35.9789 7.97842 33.6311 5.99648 31.7814 5.99648H10.194ZM0 11.5646C0 5.68869 4.09551 0 10.194 0H31.7814C37.8799 0 41.9754 5.68869 41.9754 11.5646V54.3967C41.9754 60.2726 37.8799 65.9613 31.7814 65.9613H10.194C4.09551 65.9613 0 60.2726 0 54.3967V11.5646Z" fill="#11B7B7"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M29.9805 8.99507C29.9805 10.651 28.6381 11.9933 26.9822 11.9933L14.9893 11.9933C13.3334 11.9933 11.991 10.651 11.991 8.99507C11.991 7.33918 13.3334 5.99683 14.9893 5.99683L26.9822 5.99683C28.6381 5.99683 29.9805 7.33918 29.9805 8.99507Z" fill="#11B7B7"/>
      <path d="M11.9893 2.99805H29.9787V8.99453H11.9893V2.99805Z" fill="#11B7B7"/>
    </svg>
    
    <p class="say-good-bye-view__text">
      {{ 'La experiencia continúa en tu móvil' | translate }}
    </p>
  </main>
</div>

